import { render, staticRenderFns } from "./products-select-search.vue?vue&type=template&id=d43fa622&"
import script from "./products-select-search.vue?vue&type=script&lang=js&"
export * from "./products-select-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports